import type { InventoryCostCheck } from './inventory-cost-check.js';
import { type CostCheckFields, itemMatchesCostCheck } from './item-matches-cost-check.js';

/** How many tags each "Worth a look" chip would show, so its count matches the rows it filters to. */
export function costCheckTagCounts(
  items: readonly CostCheckFields[],
): Record<InventoryCostCheck, number> {
  const counts: Record<InventoryCostCheck, number> = { FAR: 0, UNPRICED: 0, NO_STANDARD: 0 };
  for (const item of items) {
    counts.FAR += item.farFromStandardTagCount;
    counts.UNPRICED += item.stockedTagCount - item.costedTagCount;
    if (itemMatchesCostCheck(item, 'NO_STANDARD')) counts.NO_STANDARD += item.stockedTagCount;
  }
  return counts;
}
